<template>
  <div v-if="!loading">
  <section v-if="comOrdersIsAny"
           class="cart">
    <div class="cart-header">
      <div class="cart-header-content">
        <h3 v-if="!isMultipleComputedOrders">
          {{ `${$t('pages.cart.total')}: ${comFormTotalPrice}` }}
        </h3>
        <h3 v-else>
          {{ $t('pages.cart.chooseYourOrder') }}
        </h3>
        <span v-if="isModeHotel">
          {{ $t('pages.cart.step') }} 1
        </span>
        <span v-else
              :class="{ hidden: computedTableNum === null }">
          {{ `${$t('pages.cart.table')}: ${computedTableNum}` }}
        </span>
      </div>
      <div class="cart-header-logo">
        <img :src="computedCompanyData.locale.logo"
             :alt="`Logo of ${computedCompanyData.locale.name}`">
      </div>
    </div>

    <div class="cart_list"
         :class="{ 'multiple-orders': isMultipleComputedOrders, 'single-order': !isMultipleComputedOrders }"
         v-for="order in computedOrders"
         :key="order.id">
      <ul v-if="isMultipleComputedOrders">
        <li>
          <ul>
            <li v-for="orderItem in order.items"
                :key="orderItem.id"
                :class="{ hidden: getItemPrice(orderItem) <= 0 }">
              <p>
                {{ orderItem.product.name }}
                <small>{{ `x ${getItemQuantity(orderItem)}` }}</small>
              </p>
              <em>
                {{ formatPrice(getItemPrice(orderItem)) }}
              </em>
            </li>
          </ul>
        </li>
      </ul>
      <ul v-else
          class="catalog_list">
        <li v-for="orderItem in order.items"
            :key="orderItem.uid">
          <CartItem :item="orderItem" />
        </li>
      </ul>
      <div class="cart_list-total"
           v-if="isMultipleComputedOrders">
        <VButton type="dark-violet"
                 v-on:click.native="openSingleOrder(order.id)">
          {{ $t('pages.cart.action') }} {{ formatPrice(getOrderSum(order)) }}
        </VButton>
      </div>
      <div class="cart-delivery-wrap"
           v-if="isModeHotel">
        <div class="cart-delivery-method">
          <h6>
            {{ $t('pages.cart.selectDeliveryMethod') }}:
          </h6>
          <RadioButton v-for="del in comDeliveryMethods"
                       :key="del.id"
                       :inputValue="del.id"
                       :label="del.name"
                       v-model="deliveryMethodId" />
        </div>
        <div class="cart-delivery-fee"
             v-if="!isSelfPickup">
          <span>{{ $t('pages.cart.deliveryFee') }}</span>
          <span class="price">{{ formatPrice(deliveryMethod.price) }}</span>
        </div>
      </div>
    </div>

    <div class="cart_options">
      <div class="vat-rules-block"
           v-if="!isMultipleComputedOrders">
        <div v-if="computedCompanyData.locale.smart_menu_sms_enabled">
          <!--              <input  type="text" ref="input" id="phone-input"  v-model="clientPhone" v-mask="'+____________'">-->
          <VuePhoneNumberInput v-model="clientPhone"
                               default-country-code="PL"
                               @update="updatePhone"
                               :no-example="true"
                               :preferred-countries="['PL', 'DE', 'ES', 'FR', 'UA', 'US']"
                               :translations="getPhoneInputTranslations()"
                               :border-radius="5"
                               required />
          <div class="phone_info">
            <svg width="16"
                 height="16"
                 viewBox="0 0 16 16"
                 fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path d="M8 1.5C6.71443 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4982 6.27665 13.8128 4.62441 12.5942 3.40582C11.3756 2.18722 9.72335 1.50182 8 1.5ZM8 13.5C6.91221 13.5 5.84884 13.1774 4.94437 12.5731C4.0399 11.9687 3.33495 11.1098 2.91867 10.1048C2.50238 9.09977 2.39347 7.9939 2.60568 6.927C2.8179 5.86011 3.34173 4.8801 4.11092 4.11091C4.8801 3.34172 5.86011 2.8179 6.92701 2.60568C7.9939 2.39346 9.09977 2.50238 10.1048 2.91866C11.1098 3.33494 11.9687 4.03989 12.5731 4.94436C13.1774 5.84883 13.5 6.9122 13.5 8C13.4984 9.45818 12.9184 10.8562 11.8873 11.8873C10.8562 12.9184 9.45819 13.4983 8 13.5ZM9 11C9 11.1326 8.94733 11.2598 8.85356 11.3536C8.75979 11.4473 8.63261 11.5 8.5 11.5C8.23479 11.5 7.98043 11.3946 7.7929 11.2071C7.60536 11.0196 7.5 10.7652 7.5 10.5V8C7.3674 8 7.24022 7.94732 7.14645 7.85355C7.05268 7.75979 7 7.63261 7 7.5C7 7.36739 7.05268 7.24022 7.14645 7.14645C7.24022 7.05268 7.3674 7 7.5 7C7.76522 7 8.01957 7.10536 8.20711 7.29289C8.39465 7.48043 8.5 7.73478 8.5 8V10.5C8.63261 10.5 8.75979 10.5527 8.85356 10.6464C8.94733 10.7402 9 10.8674 9 11ZM7 5.25C7 5.10166 7.04399 4.95666 7.1264 4.83332C7.20881 4.70999 7.32595 4.61386 7.46299 4.55709C7.60004 4.50032 7.75084 4.48547 7.89632 4.51441C8.04181 4.54335 8.17544 4.61478 8.28033 4.71967C8.38522 4.82456 8.45665 4.9582 8.48559 5.10368C8.51453 5.24917 8.49968 5.39997 8.44291 5.53701C8.38615 5.67406 8.29002 5.79119 8.16668 5.8736C8.04334 5.95601 7.89834 6 7.75 6C7.55109 6 7.36033 5.92098 7.21967 5.78033C7.07902 5.63968 7 5.44891 7 5.25Z"
                    fill="#7019FD" />
            </svg>
            {{ $t('pages.cart.phoneInfo') }}
          </div>

        </div>

        <!--            <div v-if="false">-->
        <!--              <input type="checkbox" id="regulamin-checkbox" v-model="regulaminAccepted" @click="showError = false">-->
        <!--              <label for="regulamin-checkbox">{{ $t('pages.cart.regulaminCheckboxTitle1') }}<a @click="showRegulamin" href="#" id="regulamin-link">{{ $t('pages.cart.regulaminCheckboxTitle2') }}</a>{{ $t('pages.cart.regulaminCheckboxTitle3') }}*</label>-->
        <!--            </div>-->

        <div class="adult-agreement"
             v-if="!isMultipleComputedOrders && cartHasAdultProducts"
             @click="showError = false">
          <CheckboxButton :label="$t('pages.cart.adultCheckboxTitle')"
                          v-model="adultAgreement" />
        </div>
        <!-- <div class="adult-agreement" v-if="!isMultipleComputedOrders && cartHasAdultProducts">
            <input type="checkbox" id="adult-checkbox" v-model="adultAgreement" @click="showError = false">
            <label for="adult-checkbox">{{ $t('pages.cart.adultCheckboxTitle') }}</label>
          </div> -->

        <div v-if="!isModeHotel"
             @click="showError = false">
          <CheckboxButton :label="$t('pages.cart.vatRulesTitle')"
                          v-model="vatRulesAccepted" />
        </div>

        <p v-if="vatRulesAccepted">{{ $t('pages.cart.vatRulesDescription') }}</p>
        <p v-if="!adultAgreement && cartHasAdultProducts && showError">{{ $t('pages.cart.adultCheckboxError') }}</p>
      </div>
      <VButton type="dark-violet"
               height="short"
               v-bind:disabled="vatRulesAccepted"
               v-on:click.native="handlePayment()"
               v-if="!isMultipleComputedOrders">
        {{ getOrderButtonText() }}
      </VButton>
      <div v-if="!isModeHotel"
           class="history-and-terms">
        <div class="btn cart_options default_button regulamin_text"
             v-if="showSmRegulamin">{{ $t('pages.cart.regulaminCheckboxTitle1') }} <a @click="showRegulamin"
             href="#"
             id="regulamin-link">{{ $t('pages.cart.regulaminCheckboxTitle2') }}</a></div>
        <a class="btn cart_options default_button"
           @click="goToHistory">{{ $t('pages.cart.showHistory') }}</a>
      </div>

    </div>
  </section>
  <section v-else
           class="cart">
    <div class="cart-header">
      <div class="cart-header-content">
        <h3>
          {{ $t('pages.cart.yourOrder') }}
        </h3>
      </div>
      <div class="cart-header-logo">
        <img :src="computedCompanyData.locale.logo"
             :alt="`Logo of ${computedCompanyData.locale.name}`">
      </div>
    </div>
    <div class="cart_plug">
      <img src="@/assets/img/cart/crying_cat.png"
           alt=""
           class="empty-cart-image">
      <p class="empty-cart-title">
        {{ $t('pages.cart.emptyCartTitle') }}
      </p>
      <p class="empty-cart-message">
        {{ $t('pages.cart.emptyCartMessage') }}
      </p>
    </div>
    <a v-if="!isModeHotel"
       class="btn cart_options default_button single-button"
       @click="goToHistory">{{ $t('pages.cart.showHistory') }}</a>
    <div class="cart_options"
         @click="goToMenu">
      <VButton type="dark-violet">
        {{ $t('pages.cart.returnToMenu') }}
      </VButton>
    </div>
  </section>
</div>
</template>

<script>
import VButton from "@/components/ui/VButton.vue";
import axios from "axios";
import { BASE_API_URL } from "@/appConstants";
import loader from "@/plugins/loader.plugin";
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import CheckboxButton from "@/components/CheckboxButton.vue";
import RadioButton from "@/components/RadioButton.vue";
import { getItemQuantity, getItemPrice } from "@/utils/itemHelper";
import CartItem from "./CartItem.vue";

export default {
  name: "CartTab",
  props: ['orderId'],
  components: {
    VButton,
    VuePhoneNumberInput,
    CheckboxButton,
    RadioButton,
    CartItem,
  },
  data() {
    return {
      isMultipleComputedOrders: false,
      computedOrders: [],
      loading: false,
      allOrders: [],
      ordersSum: 0,
      vatRulesAccepted: false,
      regulaminAccepted: false,
      buyButtonPressed: false,
      adultAgreement: false,
      showError: false,
      errorMessage: '',
      clientPhone: '',
      formattedPhone: '',
      sm_terms: this.$store.getters['getCompanyData'].locale.sm_terms,
      sm_show_terms: this.$store.getters['getCompanyData'].locale.sm_show_terms,
      activeIcon: null,
      isQsrMode: false,
      iconsOptions: {
        "vegeterian": {
          "name": "vegeterian",
          "description": "vegeterian-description",
          "icon": "iconmoon-vegeterian"
        },
        "gluten-free": {
          "name": "gluten-free",
          "description": "gluten-free-description",
          "icon": "iconmoon-gluten-free"
        },
        "chili-pepper": {
          "name": "chili-pepper",
          "description": "chili-pepper-description",
          "icon": "iconmoon-chili-pepper"
        },
        "low-calories": {
          "name": "low-calories",
          "description": "low-calories-description",
          "icon": "iconmoon-low-calories"
        },
      },
    };
  },
  directives: {
    mask: {
      inserted: function (el, binding) {

        var mask = binding.value,
          first = mask.indexOf('_'),
          // fieldsL = mask.replace(/[^_]/gm, '').length,
          clean = mask.replace(/[^0-9_]/gm, ''),
          indexes = [];

        for (var i = 0; i < clean.length; i++) {
          if (!isNaN(clean[i])) {
            indexes.push(i);
          }
        }

        el.value = mask;
        el.clean = mask.replace(/[^0-9]/gm, '');

        function maskIt() {
          var value = el.value,
            filtred = value.replace(/[^0-9]/gm, ''),
            result = '';

          if (value.length < first) {
            value = mask + value;
            filtred = value.replace(/[^0-9]/gm, '');
          }

          for (var i = 0; i < filtred.length; i++) {
            if (indexes.indexOf(i) == -1) {
              result += filtred[i];
            }
          }

          value = '';
          var cursor = 0;

          for (i = 0; i < mask.length; i++) {
            if (mask[i] == '_' && result) {
              value += result[0];
              result = result.slice(1);
              cursor = i + 1;

            } else {
              value += mask[i];
            }
          }

          if (cursor < first) {
            cursor = first;
          }

          el.value = value;

          el.clean = el.value.replace(/[^0-9]/gm, '');

          el.setSelectionRange(cursor, cursor);
        }

        el.addEventListener('focus', function (event) {
          event.preventDefault();
        });

        el.addEventListener('click', function (event) {
          event.preventDefault();
          var start = el.value.indexOf('_');

          if (start == -1) {
            start = el.value.length;
          }

          el.setSelectionRange(start, start);

        });

        el.addEventListener('paste', function () {
          var start = el.selectionStart;

          if (start < first) {
            el.value = '_' + el.value;
          }
        });

        el.addEventListener('input', function (event) {
          var start = el.selectionStart;
          maskIt(event, start);
        });

      }
    }
  },
  mounted() {
    this.showLoader();
    // this.isQsrMode = this.$store.getters['getIsModeQSR'];
    this.isQsrMode = this.$store.getters['getCartEnabled'];

    if (this.deliveryMethod === null) {
      this.deliveryMethod = this.comDeliveryMethods[0];
    }
    // this.$store.dispatch('cartStore/FETCH_AND_SET_ORDERS_BY_TABLE', this.$store).then(this.setComputedOrders)
    this.getComputedOrders();
    this.updateStoreOrderId();

    // this.clientPhone = window.localStorage.getItem('sm_clientPhone') || '';
  },
  computed: {
    computedTableNum: function () {
      return this.$store.getters['getTableName'];
    },
    computedCompanyData: function () {
      return this.$store.getters['getCompanyData'];
    },
    computedOrdersAmount: function () {
      let orders = this.computedOrders,
        amount = 0;
      if (orders.length) {
        orders.forEach(order => {
          if (order.amount) {
            amount += order.amount;
          } else {
            order.items.forEach(item => {
              amount += item.amount;
              // amount += item.price * item.count
            });
          }
        });
      }
      return this.formatPrice(amount);
    },
    countCartItems() {
      let amount = 0,
        orders = this.computedOrders;

      if (orders.length) {
        orders.forEach(item => {
          amount += item.count;
        });
      }
      return amount;
    },
    cartHasAdultProducts() {
      return this.computedOrders.some(order => order.items.some(item => item.is_adult));
    },
    computedCurrentLocale: function () {
      let locale = null,
        prefLangCode = this.$store.state.prefLangCode ? this.$store.state.prefLangCode : 'en';
      this.$store.state.companyData.languages.forEach((lang) => {
        if (lang.code === prefLangCode) {
          locale = lang;
          return;
        }
      });
      return locale;
    },
    showSmRegulamin() {
      return (this.sm_show_terms && this.sm_terms && this.sm_terms.length > 0);
    },
    isModeHotel() {
      return this.$store.getters['getIsModeHOT'];
    },
    comDeliveryMethods() {
      return this.computedCompanyData.locale.sm_delivery_methods;
    },
    comFormTotalPrice() {
      if (this.$store.getters['getIsModeWMM']) {
        return this.ordersSum;
      }
      return this.$store.getters['cartStore/getFormattedCartTotal'];
    },
    deliveryMethod: {
      get() {
        return this.$store.getters['cartStore/getDeliveryMethod'];
      },
      set(val) {
        this.$store.dispatch('cartStore/SET_DELIVERY_METHOD', val);
      }
    },
    deliveryMethodId: {
      get() {
        return this.deliveryMethod.id;
      },
      set(val) {
        this.deliveryMethod = this.comDeliveryMethods.find(del => del.id === val);
      }
    },
    isSelfPickup() {
      return this.deliveryMethod && this.deliveryMethod.self_pickup === 1;
    },
    comOrdersIsAny() {
      if(this.computedOrders.length === 0) {
        return false;
      }
      return this.computedOrders.some(order => order.items.length > 0);
    }
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' }).format(price);
    },
    showErrorMesage(message) {
      this.showError = true;
      this.errorMessage = message;
    },
    handlePayment() {
      if (this.cartHasAdultProducts && !this.adultAgreement) {
        this.showErrorMesage(this.$t('pages.cart.adultCheckboxError'));
        return;
      }

      if (this.isModeHotel) {
        this.$router.push({ name: 'payment' });
        return;
      }

      // if(!this.regulaminAccepted) {
      //   this.showErrorMesage(this.$t('pages.cart.regulaminCheckboxError'));
      //   return;
      // }

      // return true;
      if (this.computedCompanyData.locale.smart_menu_sms_enabled) {
        var phone = this.formattedPhone.e164;

        if (!this.formattedPhone.isValid) {
          this.$toast.error(this.$t('pages.cart.invalidPhone'), { position: 'top-center' });
          return;
        }
        window.localStorage.setItem('sm_clientPhone', phone);
        this.$store.dispatch('cartStore/SET_CLIENT_PHONE', phone);
      }

      // if(!this.vatRulesAccepted) {
      //   this.buyButtonPressed = true;
      //   console.log(2);
      //   return
      // }
      this.$store.dispatch('cartStore/MAKE_A_PAYMENT');
    },
    removeFromCart(item) {
      this.$store.dispatch('cartStore/REMOVE_ITEM_FROM_CART', item.id)
        .then(() => this.$toast.success(this.$t('removedFromCart'), { position: 'top-center' }));
    },
    goToMenu() {
      this.$router.push({ name: 'menu' });
    },
    goToHistory() {
      this.$router.push({ name: 'history' });
    },
    openSingleOrder(orderId) {
      this.$router.push('/bill/' + orderId);
    },
    getOrderSum(order) {
      var total = 0;

      order.items.forEach(item => {
        if (item.amount) {
          total = total + parseFloat(item.amount);
        } else {
          total = total + parseFloat(item.price) * parseFloat(item.count);
        }
        // total = total + parseFloat(item.amount);
      });
      return total;
    },
    getOrdersSum() {
      var total = 0;
      //if wmm mode
      if (this.$store.getters['getIsModeWMM']) {
        this.computedOrders.forEach(order => {
          total = total + parseFloat(order.amount);
          // order.items.forEach(item => {
          //   if(item.amount) {
          //     total = total + parseFloat(item.amount);
          //   } else {
          //     total = total + parseFloat(item.price) * parseFloat(item.count);
          //   }
          // });
        });
      } else {
        this.computedOrders.forEach(order => {
          order.items.forEach(item => {
            if (item.amount) {
              total = total + parseFloat(item.amount);
            } else {
              total = total + parseFloat(item.price) * parseFloat(item.count);
            }
          });
        });
      }

      if (this.isModeHotel && this.deliveryMethod) {
        total += this.deliveryMethod.price;
      }


      this.ordersSum = this.formatPrice(total);
    },
    setIsMultipleComputedOrders: function () {
      this.getOrdersSum();
      this.hideLoader();
      this.isMultipleComputedOrders = !this.orderId && this.computedOrders.length > 1;
      this.updateStoreOrderId();
    },
    getOrders() {
      var instance = this;
      axios({
        method: "get",
        url: `${BASE_API_URL}smart-menu/get-table-orders/${this.$store.getters['getTableData'].id}`
      }).then(response => {

        var placedOrders = [];
        if (response.data.orders.length) {
          response.data.orders.forEach(order => {
            if (order.status === 'PLACED' && instance.getOrderSum(order) > 0) {
              placedOrders.push(order);
            }
          });
        }

        instance.setAllOrders(placedOrders);
      }).catch(error => {
        this.hideLoader();
        console.log(error);
      });
    },
    getComputedOrders: function () {
      if (this.$store.getters['getIsModeWMM']) {
        this.getOrders();
      } else {
        let orders = [];
        let items = this.$store.getters['cartStore/getCart'];

        if (items.length) {
          orders = [{
            id: 1,
            items: this.$store.getters['cartStore/getCart']
          }];
        }
        // this.$store.dispatch('cartStore/SET_ORDERS_BY_TABLE', orders)
        // console.log(orders)
        this.setAllOrders(orders);
      }
    },
    setComputedOrders: function () {
      if (this.orderId) {
        this.computedOrders = this.allOrders.filter(order => parseInt(order.id) === parseInt(this.orderId));
      } else {
        this.computedOrders = this.allOrders;
      }

      this.setIsMultipleComputedOrders();
    },
    getProductName: function (orderItem) {
      return orderItem.product.name;
    },
    setAllOrders: function (orders) {
      if (this.$store.getters['getIsModeWMM']) {
        orders.forEach(order => {
          var orderItems = [];
          order.items.forEach(item => {
            if (item.quantity > 0) {
              orderItems.push(item);
            }
          });
          order.items = orderItems;
        });
      }

      this.allOrders = orders;
      this.setComputedOrders(orders);
    },
    showRegulamin() {
      this.$emit('show-regulamin');
    },
    showLoader() {
      this.loading = true;
      loader.show();
    },
    hideLoader() {
      this.loading = false;
      loader.hide();
    },
    updateStoreOrderId() {
      var orderId = this.orderId;
      if (!orderId && this.computedOrders.length > 0) {
        orderId = this.computedOrders[0].id;
      }
      this.$store.dispatch('cartStore/SET_ORDER_ID', orderId);
    },
    unmaskedValue: function () {
      return this.$refs.input.clean;
    },
    isValidClientPhone() {
      var phone = this.unmaskedValue();
      return phone.length >= 11;
    },
    showIconDetails(icon) {
      this.activeIcon = this.iconsOptions[icon];
      this.$refs.iconDetails.open();
    },
    getItemCount: function () {
      return this.itemCount;
    },
    updateItemQuantity(orderItem, quantity) {
      this.$store.dispatch('cartStore/UPDATE_ITEM_QUANTITY', { id: orderItem.id, quantity });
      this.setComputedOrders();
    },
    updatePhone(value) {
      this.formattedPhone = value;
    },
    getPhoneInputTranslations() {
      return {
        countrySelectorLabel: this.$t('pages.cart.countrySelectorLabel'),
        countrySelectorError: this.$t('pages.cart.countrySelectorError'),
        phoneNumberLabel: this.$t('pages.cart.phoneNumberLabel')
      };
    },
    getOrderButtonText() {
      var text = this.$t('pages.cart.pay');
      if (this.isModeHotel) {
        text = this.$t('pages.cart.continue'); //TODO add de end es transaltions
      }
      else if (this.$store.getters['getIsModeQSR']) {
        text = this.$t('pages.cart.orderAndPay');
      }
      else if (this.$store.getters['getIsModeSOT']) {
        text = this.$t('pages.cart.order');
      }
      return text;
    },
    getItemQuantity(item) {
      return getItemQuantity(item);
    },
    getItemPrice(item, obj) {
      return getItemPrice(item, obj);
    }
  },
  watch: {
    $route(to) { //to, from
      this.showLoader();
      if (to.fullPath === '/bill') {
        this.getComputedOrders();
      } else {
        this.setComputedOrders();
      }

      // this.show = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/scss/assets/variables";

ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
}

h6 {
  margin: 0;
  padding: 0;

  font: {
    size: 16px;
    weight: 700;
  }

  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
}

.cart {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 22px;
  height: 100%;
}

.cart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;

  &-content {
    position: relative;

    margin: 12px 0;

    &>h3 {
      font-size: 24px;
      font-weight: 700;
      margin: 20px 0;
      padding: 0;
    }

    &>span {
      position: absolute;
      bottom: 0;

      font: {
        size: 14px;
        weight: 500;
      }

      color: #929292;

      &:is(.hidden) {
        visibility: hidden;
      }
    }
  }

  &-logo {
    width: 66px;
    height: 66px;
    overflow: hidden;
    flex-shrink: 0;

    &>img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}


.cart_plug {

  text-align: center;
  height: 100%;
  padding-top: 25%;

  .empty-cart-title {
    padding: 10% 0 5% 0;
    font-size: 1.5rem;
    color: black;
  }
}

.cart_list.multiple-orders {
  display: flex;
  flex-direction: column;
  border: 2px solid rgba(230, 230, 230, 1);
  padding: 12px;
  gap: 12px;
  border-radius: 20px;
  box-shadow: 0 4px 30px 0 #0000001A;
  background-color: rgba(245, 245, 245, 1);

  &>ul {
    display: flex;
    flex-direction: column;
    gap: 30px;

    li {
      width: 100%;

      &>span {
        display: block;
        text-align: center;

        font: {
          weight: 700;
          size: 16px;
        }

        ;
        color: $color_black;
      }

      &>ul {
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 12px;
        background-color: white;
        border-radius: 12px;

        li {
          display: flex;
          justify-content: space-between;
          align-items: center;

          p {
            color: #000000;
            font-size: 14px;
            font-weight: 500;
            margin: 0;

            small {
              color: #7019FD;
              font-size: 14px;
              font-weight: 500;
            }

          }

          em {
            color: $color_black;

            font: {
              size: 14px;
              style: normal;
              weight: 700;
            }
          }
        }
      }
    }
  }

  .cart_list-total {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #E6E6E6;
    padding-top: 22px;
    color: $color_black;

    a.btn {
      height: 42px;
      width: 100%;
      font-size: 14px;
      border-radius: 10px;
    }

    span {
      font: {
        weight: 700;
        size: 16px;
      }
    }
  }

  &.multiple-orders {
    .cart_list-total {
      padding-top: 10px;
      border-top: none;

      div {
        width: 100%;
      }
    }
  }

  &.single-order {
    box-shadow: none;
    border: none;
    padding: 0;
  }
}

.cart_options {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: auto;
  padding-bottom: 24px;


  &.default_button {
    color: #6466f1;
    text-decoration: underline;
    font-size: 1.2em;
    text-align: center;
    padding-bottom: 15px;
  }

  &.regulamin_text {
    text-decoration: unset;
    display: block;

    a {
      color: #6466f1;
      text-decoration: underline;
    }
  }
}

.cart-delivery-wrap {
  margin-top: 22px;

  .cart-delivery-method {
    display: grid;
    gap: 14px;
  }

  .cart-delivery-fee {
    display: flex;
    justify-content: space-between;

    margin-top: 22px;

    font-weight: 510;
    font-size: 14px;
    letter-spacing: 0px;

    color: black;

    .price {
      font-weight: 700;

      margin-right: 12px;
    }
  }
}



.history-and-terms {
  //display: flex;
  width: 100%;
  justify-content: space-between;
}

.vat-rules-block {
  label {
    font-size: 14px;
  }

  input[type="checkbox"] {
    width: 16px;
    height: 16px;
  }

  #phone-input {
    width: 100%;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    border: 2px solid #E6E6E6;
    padding: 12px 20px;
    border-radius: 12px;
    box-shadow: 0 4px 30px 0 rgba(0, 0, 0, 0.1019607843);
    margin-top: 15px;
    color: black;
    height: 50px;
  }

  p {
    padding: 10px;
    color: red;
    border: 1px solid #FF3737;
    background: #FFDBDB36;
    border-radius: 13px;
    margin: 5px 0px 0px;
  }

  .phone_info {
    display: flex;
    margin-top: 10px;
    padding-left: 3px;
    margin-bottom: 25px;

    img {
      height: 16px;
      width: 16px;
      margin-right: 7px;
    }

    svg {
      margin-right: 7px;

    }
  }
}

.adult-agreement {
  margin-bottom: 12px;

  label {
    padding-left: 0;
  }
}

.catalog_list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}


.v-counter {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  &__value {
    min-width: 22px;
    display: flex;
    align-items: center;
    justify-content: center;

    &>span {
      font: {
        weight: 700;
        size: 16px;
      }

      letter-spacing: -1px;
      color: $color_black;
    }
  }
}

.hidden {
  display: none !important;
}

#regulamin-link {
  text-decoration: underline;
}
</style>

<style>
.bottom-sheet__content {
  touch-action: unset !important;
  -webkit-user-select: unset !important;
  -webkit-touch-callout: unset !important;
  -webkit-user-drag: unset !important;
}
</style>
